import React, { useState } from "react";

function FAQItem(Question, Answer) {
  const [isActive, setIsActive] = useState(false);

  const toggle = () => {
    setIsActive(!isActive);
  };

  return (
    <div className="faq">
      <div className="faq-title">{Question}</div>
      <button className="faq-toggle" onClick={toggle}>
        Toggle
      </button>

      <div className={`faq-content ${isActive ? "active" : "inactive"}`}>
        {Answer}
      </div>
    </div>
  );
}

export default FAQItem;
